import ConfirmDialog from '../../../components/ConfirmDialog';

type Translate = (key: string, options?: Record<string, unknown>) => string;

interface EpisodeConfirmDialogsProps {
  confirmRegenerate: boolean;
  confirmRematchAssets: boolean;
  confirmDeleteResource: { resourceId: string; shotId: string } | null;
  deleteShotTarget: { id: string; index: number } | null;
  deleteShotStep: 1 | 2;
  deletingShotLoading: boolean;
  t: Translate;
  onCancelRegenerate: () => void;
  onConfirmRegenerate: () => void;
  onCancelRematchAssets: () => void;
  onConfirmRematchAssets: () => void;
  onCancelDeleteResource: () => void;
  onConfirmDeleteResource: () => void;
  onCancelDeleteShot: () => void;
  onAdvanceDeleteShotStep: () => void;
  onConfirmDeleteShot: () => void;
}

export default function EpisodeConfirmDialogs({
  confirmRegenerate,
  confirmRematchAssets,
  confirmDeleteResource,
  deleteShotTarget,
  deleteShotStep,
  deletingShotLoading,
  t,
  onCancelRegenerate,
  onConfirmRegenerate,
  onCancelRematchAssets,
  onConfirmRematchAssets,
  onCancelDeleteResource,
  onConfirmDeleteResource,
  onCancelDeleteShot,
  onAdvanceDeleteShotStep,
  onConfirmDeleteShot,
}: EpisodeConfirmDialogsProps) {
  return (
    <>
      <ConfirmDialog
        open={confirmRegenerate}
        onCancel={onCancelRegenerate}
        onConfirm={onConfirmRegenerate}
        title={t('confirmRegenerate.title')}
        message={t('confirmRegenerate.message')}
        confirmText={t('confirmRegenerate.confirm')}
        confirmDanger
      />
      <ConfirmDialog
        open={confirmRematchAssets}
        onCancel={onCancelRematchAssets}
        onConfirm={onConfirmRematchAssets}
        title={t('confirmRematch.title')}
        message={t('confirmRematch.message')}
        confirmText={t('confirmRematch.confirm')}
        confirmDanger
      />
      <ConfirmDialog
        open={!!confirmDeleteResource}
        onCancel={onCancelDeleteResource}
        onConfirm={onConfirmDeleteResource}
        title={t('confirmDeleteResource.title')}
        message={t('confirmDeleteResource.message')}
        confirmText={t('delete', { ns: 'common' })}
        confirmDanger
      />
      <ConfirmDialog
        open={!!deleteShotTarget && deleteShotStep === 1}
        onCancel={onCancelDeleteShot}
        onConfirm={onAdvanceDeleteShotStep}
        title={t('confirmDeleteShot.step1Title')}
        message={t('confirmDeleteShot.step1Message', { index: deleteShotTarget?.index })}
        confirmText={t('confirmDeleteShot.step1Confirm')}
        confirmDanger
      />
      <ConfirmDialog
        open={!!deleteShotTarget && deleteShotStep === 2}
        onCancel={onCancelDeleteShot}
        onConfirm={onConfirmDeleteShot}
        title={t('confirmDeleteShot.step2Title')}
        message={t('confirmDeleteShot.step2Message')}
        confirmText={t('confirmDeleteShot.step2Confirm')}
        confirmDanger
        loading={deletingShotLoading}
      />
    </>
  );
}
